import React, {Component} from "react";
import { Link } from "react-router-dom";

export class FooterComponentOpenData extends Component{
    render(){
        return(
            <div>
                <footer id="footer" data-aos="fade-in">
                    <div className="footer-top">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-3 col-md-6 footer-link text-center">
                                    <center>
                                        <div className="logo-footer">
                                            <img src={`${process.env.PUBLIC_URL}/sampang.png`} alt="Sampang" />
                                        </div>
                                    </center>
                                    <p>
                                        Jl. Jamaluddin No.1A, <br/> Kec. Sampang, Kab. Sampang, <br/>
                                        Jawa Timur 69213
                                    </p>
                                </div>
                                <div className="col-lg-3 col-md-6 footer-links">
                                    <h4>Menu</h4>
                                    <ul>
                                        <li><i className="bx bx-chevron-right"></i> <Link to="/open_data">Beranda</Link></li>
                                        <li><i className="bx bx-chevron-right"></i> <Link to="/open_data/kumpulan_data">Kumpulan Data</Link></li>
                                        <li><i className="bx bx-chevron-right"></i> <Link to="/open_data/organisasi">Organisasi</Link></li>
                                        <li><i className="bx bx-chevron-right"></i> <Link to="/open_data/kategori">Kategori</Link></li>
                                        <li><i className="bx bx-chevron-right"></i> <Link to="/open_data/infografik">Infografik</Link></li>
                                        <li><i className="bx bx-chevron-right"></i> <Link to="/open_data/tentang">Tentang</Link></li>
                                    </ul>
                                </div>
                                <div className="col-lg-3 col-md-6 footer-link">
                                    <h4>Kontak</h4>
                                    <p className="flex-content">
                                        <span><i className="bx bx-phone font-size-20 mr-1"></i></span>
                                        <span> (0323) 325987 / 321550</span>
                                    </p>
                                    <p className="flex-content">
                                        <span><i className="bx bx-envelope font-size-20 mr-1"></i></span>
                                        <span> info@sampangkab.go.id</span>
                                    </p>
                                </div>

                                <div className="col-lg-3 col-md-6 footer-links">
                                    <h4>Ikuti Kami</h4>
                                    <p>Ikuti kami pada sosial media berikut ini</p>
                                    <div className="social-links mt-3">
                                        <a href="#" className="twitter"><i className="bx bxl-twitter"></i></a>
                                        <a href="#" className="facebook"><i className="bx bxl-facebook"></i></a>
                                        <a href="#" className="instagram"><i className="bx bxl-instagram"></i></a>
                                        <a href="#" className="youtube"><i className="bx bxl-youtube"></i></a>
                                        <a href="#" className="linkedin"><i className="bx bxl-linkedin"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="container py-4">
                        <div className="copyright">
                            &copy; Copyright <strong><span>2024</span></strong>. All Rights Reserved
                        </div>
                    </div>
                </footer>
                <a href="#" className="back-to-top d-flex align-items-center justify-content-center"><i className="bi bi-arrow-up-short"></i></a>
            </div>
        )
    }
}

export default FooterComponentOpenData;